export const EMO_3122_RECIPE_KEY = 'EMO-3122_recipe';
